<template>
  <div class="CreateNewProjectRevComponent">

    <b-form >

      <b-form-group id="input-group-Name" :label="lang.label_Name" label-for="input-2">
        <b-form-input
          id="input-Name"
          v-model="form.Name"
          size="sm"
             
          disabled
        ></b-form-input>

        
      </b-form-group>

      <b-form-group id="input-group-Revision" :label="lang.label_Revision" label-for="input-2">
        <b-form-input
          id="input-Revision"
          v-model="form.Revision"
          size="sm"
          class="input-oldrev"          
          disabled
        ></b-form-input>
        <b-form-input
          id="input-NewRevision"
          v-model="form.NewRevision"
          :placeholder="lang.placeholder_Revision"
          size="sm"
          class="input-newrev"         
          required
          aria-describedby="input-Revision-feedback"
          :state="validation_NewRevision"
        ></b-form-input>

        <b-form-invalid-feedback id="input-Revision-feedback" :state="validation_NewRevision">
          {{lang.validinfo_Revision}}
        </b-form-invalid-feedback>
      </b-form-group>

    </b-form>
  </div>
</template>

<script>


export default {
  name: "CreateNewProjectRevComponent",
  components: {



  },
  props:{
    lang: Object
  },
  data () {
    return {
      form: {

        Name: this.$store.getters.selectedProjectRow.name,
        Revision: this.$store.getters.selectedProjectRow.revision,
        projectId: this.$store.getters.selectedProjectRow.projectId,
        NewRevision: "",
        
      },
      //validation_Revision: null,
      
    }
  },
  computed: {
    
    validation_NewRevision() {
      if (this.form.NewRevision.length == 0){
        return null;
      }
      return this.form.Revision.length > 0
    },
    
  },
  created() {


  },
  updated(){
    

    this.$store.dispatch(this.$store.getters.sectionPrefix + "_createProjectForm", this.form)
    
  },
  methods: {

  }
}
</script>
<style lang="scss">
  .CreateNewProjectRevComponent{
      .input-oldrev{
          width: 150px;
          float: left;
          margin-right: 10px;
      }
      .input-newrev{
          width: 150px;
          
      }
  }



</style>



// WEBPACK FOOTER //
// src/components/shared/CreateNewProjectRevComponent.vue